import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon, UploadIcon } from '../common/mdPageIcons';
import * as mesasService from '../../services/mesas/mesasService';
import {
  classifyMesasError,
  toBulkUploadMesasPayload,
  validateBulkUploadForm
} from '../../services/mesas/mesasDto';

export class CargarMesas extends Component {
  static displayName = CargarMesas.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      base64: '',
      selectedFileName: '',
    };
    this.fileInputRef = React.createRef();
  }

  async componentDidMount() {
    await constantClass.canAccess('WWMesaExamen');
  }

  handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      this.setState({
        showErrorMessage: false,
        errorMessage: '',
        success: false,
        base64,
        selectedFileName: file.name,
      });
    };
    reader.onerror = (error) => {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Error al leer el archivo:' + error,
        base64: '',
        selectedFileName: '',
      });
    };
  };

  handleClearFile = () => {
    if (this.state.loading) {
      return;
    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
    this.setState({
      base64: '',
      selectedFileName: '',
      showErrorMessage: false,
      errorMessage: '',
      success: false,
    });
  };

  handleConfirmButton = () => {
    if (!validateBulkUploadForm(this.state.base64)) {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
      return;
    }
    this.saveStudent();
  };

  render() {
    const { loading, selectedFileName } = this.state;
    const fileHint = selectedFileName || 'Ningún archivo seleccionado';

    return (
      <div className="md-page md-cargar-mesas">
        <Link className="md-page__back-link" to="/md-mex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Cargar Mesas de Examen</h1>
        </div>
        <p className="md-page__subtitle">
          Seleccione el archivo con las mesas de examen para generarlas en el sistema.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Generando mesas de examen...</div>
          ) : null}
          {this.state.success && !loading ? (
            <div className="md-page__success">Generación de mesas de examen exitosa</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <h2 className="md-page__form-section-title">Archivo de mesas</h2>
          <input
            ref={this.fileInputRef}
            className="md-page__file-input"
            type="file"
            onChange={this.handleFileChange}
            disabled={loading}
          />
          <p className="md-page__file-hint">*{fileHint}*</p>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              <UploadIcon />
              Cargar mesas
            </button>
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--secondary"
              onClick={this.handleClearFile}
              disabled={loading}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true, success: false });
    try {
      await mesasService.uploadMesasBulk(toBulkUploadMesasPayload(this.state.base64));
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = '';
      }
      this.setState({
        loading: false,
        success: true,
        errorMessage: '',
        base64: '',
        selectedFileName: '',
      });
    } catch (error) {
      const outcome = classifyMesasError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
